import { defineComponent as _defineComponent } from 'vue'
import Header from './components/Header/Header.vue';
import List from './components/List/List.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Left',
  props: {
  selected: {
    type: Object,
    default: () => ({})
  },
  roles: {
    type: Array,
    default: () => ([])
  }
},
  emits: ['selected-role-changed'],
  setup(__props, { emit }) {

const props = __props;




function handleSelectedRoleChanged(event: any) {
  emit('selected-role-changed', event);
}


return { __sfc: true,props, emit, handleSelectedRoleChanged, Header, List }
}

})